import { getToken } from "../cookie/authCookie";
import axiosInstance from "./config/axiosConfigs";

export const UserAPI = {

  getCurrentUser: async function () {
    const response = await axiosInstance.request({
      url: `/user/getLoggedInUser`,
      method: "GET",
      withCredentials: true,
      // timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    
    return transformUserInfo(response.data);
  },
  getAdminUserID: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/user/get-admin-user-id/${clubId}`,
      method: "GET",
      withCredentials: true,
      // timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getAllUsersForAClub: async function (clubId) {

    // 
    const response = await axiosInstance.request({
      url: `/user/club/` + clubId,
      method: "GET",
      withCredentials: true,
      // timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getAllUsersFormClub: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/user/club/all-user/${clubId}`,
      method: "GET",
      withCredentials: true,
      // timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },

  getAllMembersForAClub: async function (clubId,pageNumber,pageSize,searchKey,filterData) {
    const response = await axiosInstance.request({
      url: `/user/all-member/club/${clubId}?pageNumber=${pageNumber}&pageSize=${pageSize}&searchKey=${searchKey}`,
      method: "POST",
      withCredentials: true,
      // timeout: 2000,
      data: filterData,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getAllMemberAndPlayer: async function (clubId,pageSize,pageNumber,searchKey,filterData) {
    const response = await axiosInstance.request({
      url: `/user/all-player/club/${clubId}?pageSize=${pageSize}&pageNumber=${pageNumber}&searchKey=${searchKey}`,
      method: "POST",
      withCredentials: true,
      data: filterData,
      // timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  
  getTotalMemberAndPlayer: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/user/member/player/total/${clubId}`,
      method: "GET",
      withCredentials: true,
      // timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },

  getAllMembersForPrivilege: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/user/users/club/` + clubId,
      method: "GET",
      withCredentials: true,
      // timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },


  getUserClubInfo: async function (userId, clubId) {
    const response = await axiosInstance.request({
      url: `/user/userId/` + userId + `/clubId/` + clubId,
      method: "GET",
      withCredentials: true,
      timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getUsersBYClubForChat: async function (clubId, userId, pageSize = 30, pageNumber = 0, searchKey="") {
    const response = await axiosInstance.request({
      url: `/user/add-chat-user/${clubId}/${userId}?pageSize=${pageSize}&pageNumber=${pageNumber}&searchKey=${searchKey}`,
      method: "GET",
      withCredentials: true,
      timeout: 20000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getAllClubUserByName: async function (clubId, name) {
    const response = await axiosInstance.request({
      url: `/user/search/club/${clubId}?searchKey=${name}`,
      method: "GET",
      withCredentials: true,
      timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  
  getAllChat: async function (userId, clubId, pageSize, pageNumber, searchKey) {
    const response = await axiosInstance.request({
      url: `/chat/club/${clubId}/user/${userId}?pageSize=${pageSize}&pageNumber=${pageNumber}&searchKey=${searchKey}`,
      method: "GET",
      withCredentials: true,
      timeout: 20000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  
  getAllFeatureAndPrivilege: async function (userId) {
    const response = await axiosInstance.request({
      url: `/user/privileges/${userId}`,
      method: "GET",
      withCredentials: true,
      // timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  
  
  getAllPrivilege: async function () {
    const response = await axiosInstance.request({
      url: `/privilege`,
      method: "GET",
      withCredentials: true,
      // timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  

  getUsersForNotifications: async function (groupNames,clubId) {
    const response = await axiosInstance.request({
      url: `/user/club/${clubId}/group?` + groupNames,
      method: "GET",
      withCredentials: true,
      timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },

  registerGuest: async function (guestRegistration) {

    const response = await axiosInstance.request({
      url: `/register/guest-registration`,
      method: "POST",
      data: guestRegistration,
      timeout: 20000
    });
    return response.data
  },

  registerUser: async function (userRegistration) {

    const response = await axiosInstance.request({
      url: `/register/user-registration`,
      method: "POST",
      data: userRegistration,
      timeout: 20000
    });
    return response.data
  },
  createMemberUser: async function (userRegistration) {
    const response = await axiosInstance.request({
      url: `/auth/create-member`,
      method: "POST",
      data: userRegistration,
      timeout: 20000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  deleteClubMember: async function (userId, clubId) {
    const response = await axiosInstance.request({
      url: `/auth/delete-member/${userId}/club/${clubId}`,
      method: "DELETE",
      timeout: 20000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  updateUser: async function (userUpdateData, userId, clubId,image) {
    let formData=new FormData();
    formData.append("image", image);
    formData.append("userData", JSON.stringify(userUpdateData));
    const response = await axiosInstance.request({
      url: `/user/${userId}/club/${clubId}`,
      method: "PUT",
      data:formData,
      // timeout: 2000,
      headers: { 
        Authorization: `Bearer ${getToken()}` 
      },
    });
    return response.data
  },

  updatePrivileges: async function (userId,requestData) {
    
    const response = await axiosInstance.request({
      url: `/user/privilege/${userId}`,
      method: "PUT",
      data: requestData,
      // timeout: 2000,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
    });
    return response.data
  },
  updateUserRole: async function (userId,roleNames) {
    
    const response = await axiosInstance.request({
      url: `/user/role/${userId}`,
      method: "PUT",
      data: roleNames,
      // timeout: 2000,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
    });
    return response.data
  }
}
const transformUserInfo = (responseData) => {
  const user = {
    userId: responseData.Data.userId,
    address: responseData.Data.address,
    userName: responseData.Data.userName,
    firstName: responseData.Data.userFirstName,
    dob: responseData.Data.dob,
    lastName: responseData.Data.userLastName,
    userStatus: responseData.Data.userStatus,
    phone: responseData.Data.userPhone,
    email: responseData.Data.userEmail,
    authorities: responseData.Data.authorities,
    clubs: responseData.Data.clubs,
    isUserAdmin: responseData.Data.isUserAdmin,
    profileImage: responseData.Data.profileImage,
    isFirstSubscription: responseData.Data.isFirstSubscription,
    countryCode:'+1',
  };
  return user;
};


const transformUserCookieInfo = (responseData) => {
  const user = {
    userId: responseData.Data.userId,
  };
  return user;
};